import broadcastEmail from './broadcastEmail';

const broadcast = {
  namespaced: true,

  state() {
    return {};
  },

  mutations: {},

  actions: {},

  modules: {
    broadcastEmail,
  },
};
export default broadcast;
